<template>
  <div class="alipay-flow-page">
    <div class="phone-screen">
      <img class="screen-image" :src="screenImage" alt="电子身份证搜索结果页" />
      <button
        class="hotspot back-arrow"
        type="button"
        aria-label="返回上一页"
        @click="goBack"
      />
      <button
        class="hotspot view-now"
        type="button"
        aria-label="点击立即查看"
        @click="goSpace"
      />
    </div>
  </div>
</template>

<script>
import screenImage from "@/assets/alipay-flow-result-no-status.png";

export default {
  name: "AlipayFlowResult",
  data() {
    return {
      screenImage,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goSpace() {
      this.$router.push({ name: "AlipayFlowSpace" });
    },
  },
};
</script>

<style scoped>
.alipay-flow-page {
  min-height: 100vh;
  background: #eff2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
}

.phone-screen {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  overflow: visible;
  border-radius: 0;
}

.screen-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}

.hotspot {
  position: absolute;
  border: none;
  background: transparent;
  cursor: pointer;
}

.view-now {
  left: 13%;
  top: 35.2%;
  width: 74%;
  height: 5.2%;
}

.back-arrow {
  left: 1.5%;
  top: 1.8%;
  width: 9%;
  height: 6%;
}
</style>
